import React, { useEffect, useRef, useState } from 'react'
import ClientNavbar from './ClientNavbar'
import './Page-css/MessengerComponent.css';
import { useDispatch, useSelector } from 'react-redux';
import { setFetchedMessage } from '../../REDUX_CLIENT/fetchMessages/fetchClientMsgAction';
import { useNavigate } from 'react-router-dom';
import messageimage from "../../Assests/MessengerPlaceholder.png";
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/UserContext';
import ClientNavbar2 from './ClientNavbar2';
import { Icon } from '@iconify/react';
import { url } from '../../constants/url';
import ClientNavbar1 from './ClientNavbar1';
import { fetchClientMessages, fetchClientUserList } from '../API/Message/messageAPI';
import { io } from 'socket.io-client';

const MessengerComponent = () => {

  const navigate = useNavigate('')


  const { user, emailVer, logout, isSidebarCollapsed, userRole, fetchUnreadMessageCount } = useAuth()

  const [message, setMessage] = useState([])
  const [error, setError] = useState('')
  const [hideSendButton, setHideSendButton] = useState(true)
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredClients, setFilteredClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [openMessage, setOpenMessage] = useState(false);
  const [latestMessageTime, setLatestMessageTime] = useState({});
  const [teamLeadName, setTeamLeadName] = useState([])
  const [isLeadOnline, setIsLeadOnline] = useState(false)
  const [showClearDropdown, setShowClearDropdown] = useState(false);
  const [inputFocused, setInputFocused] = useState(false)
  const [showAIChat, setShowAIChat] = useState(false)
  const [isMobileView, setIsMobileView] = useState(false)
  const [showChatBoard, setShowChatBoard] = useState(false);
  const [showNewMessageText, setShowNewMessageText] = useState(false)


  const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

  const mainChatRef = useRef(null)

  const messageRef = useRef(null)

  const fetchedMessage = useSelector((state) => state.fetchedMessage.fetchedMessage)

  const dispatch = useDispatch()

  const handleAIChat = () => {
    setShowAIChat(true)
    setOpenMessage(false)
    setSelectedClient(false)
  }

  const handleMessageBox = (client) => {
    setSelectedClient(client);
    setOpenMessage(true);
    setMessage('');
    setShowAIChat(false)
    if (isMobileView) {
      setShowChatBoard(true);
    }
  };

  const handleBackToContacts = () => {
    setShowChatBoard(false);
    setOpenMessage(false);
    setSelectedClient(null);
  };

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
    filterClients(e.target.value);
  };

  const filterClients = (query) => {
    const filtered = teamLeadName.filter(
      (client) =>
        client.name.toLowerCase().includes(query.toLowerCase()) || client.email.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredClients(filtered);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 680);
    };
    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  // Refer messages.js file for backend code
  const fetchClients = async () => {
    try {
      const result = await fetchClientUserList();
      // console.log(result);

      if (!result) return;
      const { status, data } = result;

      if (status === 440) {
        toast.error("User logout due to inactivity");
        return logout();
      }

      if (status === 200) {
        const uniqueEmails = Array.from(
          new Map(data.map(item => [item.email, item])).values()
        );
        setFilteredClients(uniqueEmails);
        setTeamLeadName(uniqueEmails);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTextAreChange = (e) => {
    setMessage(capitalizeFirstLetter(e.target.value))
    if (e.target.value.trim() !== "") {
      setHideSendButton(false)
    } else {
      setHideSendButton(true)
    }
  }


  // Refer messages.js file for backend code
  const addMessage = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${url}/sendclientmessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({
          message,
          client: selectedClient.email
        })
      });


      if (response.ok) {
        setMessage('')
        setHideSendButton(true);
        fetchClientMessage()
        const textarea = document.getElementById("textarea");
        textarea.focus()
        mainChatRef.current.scrollTop = mainChatRef.current.scrollHeight;
      } else {
        const errorData = await response.json()
        toast.error(errorData.message, {
          position: "top-right",
          autoClose: 3000,
          pauseOnHover: false,
        });
      }
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
    } catch (error) {
      console.log(error)
    }
  }

  const readMessages = async (e) => {
    if (!selectedClient || !selectedClient.email) {
      return;
    }
    try {
      const response = await fetch(`${url}/readclientmessages`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({
          client: selectedClient.email
        })
      });

      if (response.status === 200) {
        fetchClients();
      }

    } catch (error) {
      console.log(error)
    }
  }

  // Refer messages.js file for backend code
  const fetchClientMessage = async () => {
    if (!selectedClient || !selectedClient.email) {

      return;
    }
    try {
      const response = await fetch(`${url}/fetchclientmessages?client=${selectedClient.email}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include'
      });
      if (response.ok) {
        const messageData = await response.json();
        fetchClients();
        // fetchUnreadMessageCount()
        dispatch(setFetchedMessage(messageData.messageDataWithIST));
        setIsLeadOnline(messageData.status);
        console.log(messageData.status)

        const hasUnread = messageData.messageDataWithIST.some(
          msg => msg.from === selectedClient.email && msg.read === false
        );

        setShowNewMessageText(hasUnread);

        const textarea = document.getElementById("textarea");
        if (textarea) textarea.focus();
        readMessages()

        messageRef.current?.scrollIntoView({ behavior: "instant" });
        return;
      }

      if (response.status === 404) {
        return dispatch(setFetchedMessage([]));
      }
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {

    if (emailVer.endsWith('@isecurion.com')) {
      logout()
      return;
    }
    fetchClients();
    fetchClientMessage()
    const socket = io(`${url}`);
    socket.on('clientmessage', () => {
      fetchClientMessage();
      fetchClients()
    });

    return () => {
      socket.disconnect();
    };

  }, [selectedClient]);


  useEffect(() => {
    messageRef.current?.scrollIntoView({ behavior: "instant" });
  }, [fetchClientMessage]);

  const formatTime = (date) => {
    const options = {
      timeZone: 'Asia/Kolkata',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return date.toLocaleTimeString('en-IN', options);
  };

  const formatDate = (date) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (isSameDay(date, today)) {
      return 'Today';
    }
    if (isSameDay(date, yesterday)) {
      return 'Yesterday';
    }
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    return date.toLocaleDateString('en-IN', options);
  };

  function escapeHtml(html) {
    return html.replace(/[&<>]/g, function (tag) {
      var charsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
      };
      return charsToReplace[tag] || tag;
    });
  }

  const isSameDay = (date1, date2) => {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  };

  const insertNewLine = (e) => {
    const start = e.target.selectionStart;
    const value = message;
    const newValue = value.slice(0, start) + '\n' + value.slice(start);
    setMessage(newValue);

  }


  return (
    <div className="client-table-list-dash">
      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='navbar_second'><ClientNavbar2 /></div>
      </div>
      <div className="wrap_navbar_dashboard">
        <div className={isSidebarCollapsed ? 'clientdash-navbar' : 'clientdash_close_navbar'}>
          <ClientNavbar />
        </div>

        <div className='messanger_container'>
          <div className='messanger_content'>
            <div className='messanger-main-content'>
              {/* MOBILE VIEW: Show either contacts or chat board */}
              {
                isMobileView ? (
                  <>
                    {
                      !showChatBoard ? (
                        <div className='messanger-sidebar'>
                          <div className='messanger-search-box'>
                            <div className='search-input-container'>
                              <span className='search-icon'><Icon icon="ic:round-search" width="24" height="24" /></span>
                              <input
                                type="text"
                                placeholder="Search....."
                                className='search-input'
                                onChange={handleSearchInputChange}
                                value={searchQuery}
                                onFocus={() => setInputFocused(true)}
                                onBlur={() => setInputFocused(false)}
                              />
                            </div>
                          </div>
                          <div className='messanger-users'>
                            <div className='messanger-users-details'>
                              {filteredClients.length === 0 ? (
                                <div>
                                  <p style={{ fontSize: '15px', marginLeft: '0px', marginTop: '20px' }}>Match not found</p>
                                </div>
                              ) : (
                                filteredClients?.map((client, index) => (
                                  <div className={`user-item ${selectedClient?.email === client.email ? 'selected' : ''}`}
                                    key={index} onClick={() => handleMessageBox(client)}>
                                    <div className='user-avatar'>
                                      <div className='user-avatar-circle'>
                                        {user.avatar || <Icon icon="lets-icons:user-fill" width="20" height="20" />}
                                      </div>
                                    </div>
                                    <div className='user-info'>
                                      <div className='user-name'>{client?.name}</div>
                                      {client?.unreadCount > 0 ? (
                                        <div className='user-subtitle'>{client?.unreadCount > 9 ? '9+' : client?.unreadCount}</div>
                                      ) : ''}
                                    </div>
                                    {/* <div className='user-meta'>

                                    </div> */}
                                  </div>
                                )))}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className='messanger-chat-board'>

                          {openMessage && selectedClient ? (
                            <div className='chat-container'>
                              <div className='chat-header' style={{
                                display: 'flex',
                                padding: '0'
                              }}>
                                <button className="mobile-back-btn" onClick={handleBackToContacts} style={{
                                  background: 'none',
                                  fontSize: '20px',
                                  margin: '0px',
                                  cursor: 'pointer',
                                }}>
                                  <Icon icon="ic:round-arrow-back" width="18" height="18" color='#E76A34' />
                                </button>
                                <div className='chat-user-info' style={{
                                  flex: '1',
                                }}>
                                  <div className='user-avatar-circle'>
                                    {selectedClient.name ? selectedClient.name.charAt(0).toUpperCase() : ""}
                                  </div>
                                  <div className='chat-user-details'>
                                    <h3>{selectedClient && selectedClient.name}</h3>
                                    <span className='user-status'>
                                      {isLeadOnline ? "online" : "offline"}
                                    </span>
                                  </div>
                                  <div className='user-chat-clear-button' style={{ position: 'relative' }}>
                                    <div
                                      className='chat-clear-button-icon'
                                      onClick={() => setShowClearDropdown((prev) => !prev)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <Icon icon="qlementine-icons:menu-dots-16" width="24" height="24" color='#fff' />
                                    </div>
                                    {showClearDropdown && (
                                      <div className="clear-chat-dropdown" style={{
                                        position: 'absolute',
                                        top: '110%',
                                        right: 0,
                                        background: '#E76A34',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        zIndex: 10,
                                        padding: '8px 0'
                                      }}>
                                        <div
                                          className="clear-chat-dropdown-item"
                                          style={{
                                            padding: '3px 10px',
                                            cursor: 'pointer',
                                            whiteSpace: 'nowrap',
                                            fontSize: "14px"
                                          }}
                                          onClick={() => {

                                            setShowClearDropdown(false);

                                          }}
                                        >
                                          Clear Chat
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="chat" ref={mainChatRef} id='element'>

                                {fetchedMessage.length > 0 ? (
                                  fetchedMessage.map((msg, index) => {
                                    const currentDate = new Date(msg.time);
                                    const previousDate = index > 0 ? new Date(fetchedMessage[index - 1].time) : null;
                                    const previousMsg = index > 0 ? fetchedMessage[index - 1] : null;
                                    const showDate = index === 0 || !isSameDay(currentDate, previousDate);

                                    // Determine if avatar should be shown
                                    let showAvatar = true;
                                    if (previousMsg) {
                                      // For "from" (sender) and "to" (receiver) logic, adjust as per your message schema
                                      if (
                                        msg.from === previousMsg.from &&
                                        msg.to === previousMsg.to &&
                                        isSameDay(currentDate, new Date(previousMsg.time))
                                      ) {
                                        showAvatar = false;
                                      }
                                    }
                                    const firstUnreadIndex = fetchedMessage.findIndex(
                                      msg => msg.from === selectedClient.email && msg.read === false
                                    );

                                    // Determine whether to show "New Messages"
                                    const showNewMessageDivider = index === firstUnreadIndex;

                                    return (
                                      <React.Fragment key={index}>
                                        {showDate && <div className='show_date'><h4>{formatDate(currentDate)}</h4></div>}
                                        {showNewMessageDivider && (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              textAlign: "center",
                                              margin: "16px 0",
                                              color: "#e77949ff",
                                              fontWeight: "500",
                                            }}
                                          >
                                            <span
                                              style={{
                                                flex: 1,
                                                borderBottom: "0.5px solid #e77949ff",
                                                marginRight: "8px",
                                              }}
                                            />
                                            <span style={{ fontSize: "14px" }}>New Messages</span>
                                            <span
                                              style={{
                                                flex: 1,
                                                borderBottom: "0.5px solid #e77949ff",
                                                marginLeft: "8px",
                                              }}
                                            />
                                          </div>
                                        )}
                                        <div key={index} className='user-chat-history'>
                                          {/* Avatar */}
                                          {msg.to === selectedClient.email ? (
                                            // Client's own message (align right, avatar after message)
                                            <>
                                              <div className="client_message-left">
                                                <div className="message-content">
                                                  <div className='isecurion_wrap-data'>
                                                    <p className='user-message' dangerouslySetInnerHTML={{ __html: escapeHtml(msg.message).replace(/\n/g, '<br>') }}></p>
                                                    <h6 className='message-date'>{formatTime(currentDate)}</h6>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="chat-avatar" style={{

                                                visibility: showAvatar ? 'visible' : 'hidden',
                                              }}>
                                                {msg?.from?.charAt(0).toUpperCase() || "U"}
                                              </div>

                                            </>
                                          ) : (
                                            // Other user's message (align left, avatar before message)
                                            <>

                                              <div className="chat-avatar" style={{

                                                visibility: showAvatar ? 'visible' : 'hidden',
                                              }}>
                                                {selectedClient?.name?.charAt(0).toUpperCase() || "U"}
                                              </div>

                                              <div className="isecurion_message_right">
                                                <div className="message-content">
                                                  <div className='isecurion_wrap-data'>
                                                    <p className='user-message' dangerouslySetInnerHTML={{ __html: escapeHtml(msg.message).replace(/\n/g, '<br>') }}></p>
                                                    <p className='message-date'>{formatTime(currentDate)}</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </React.Fragment>
                                    );
                                  })
                                ) : (
                                  <div className='empty_chat_message_client'>
                                    <h1>Nothing's being discussed right now</h1>
                                  </div>
                                )}
                                <div ref={messageRef} />
                              </div>

                              <div className='chat-input-container'>
                                <div className='chat-input-wrapper'>
                                  <input
                                    id='textarea'
                                    type="text"
                                    placeholder={selectedClient ? `Message ${selectedClient.name}` : 'Message ISECURION'}
                                    value={message}
                                    onChange={handleTextAreChange}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" && e.shiftKey) {
                                        e.preventDefault();
                                        insertNewLine(e);
                                      }
                                      else if (e.key === "Enter" && message.trim() !== "") {
                                        addMessage(e);
                                      }
                                    }}
                                    className='chat-input'
                                  />
                                  {/* {!hideSendButton && (
                          <div className='message-send-icon' onClick={addMessage}>
                            <Icon icon="lets-icons:send-hor-duotone-line" width="24" height="24" />
                          </div>
                        )} */}
                                  <button
                                    className="message-send-icon"
                                    onClick={addMessage}
                                    disabled={hideSendButton}
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      backgroundColor: "#E76A34",
                                      borderRadius: "50%",
                                      border: "none",
                                      cursor: hideSendButton ? "not-allowed" : "pointer",
                                      padding: 0,
                                      opacity: hideSendButton ? 0.5 : 1,
                                      filter: hideSendButton ? "grayscale(40%) brightness(0.8)" : "none",
                                    }}
                                    aria-label="Send message"
                                    type="button"
                                  >
                                    <Icon icon="lsicon:send-filled" width="16" height="16" color="#fff" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className='no-chat-selected'>
                              <div className='no-chat-message'>
                                <h3>Select a conversation</h3>
                                <p>Choose from your existing conversations or start a new one</p>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    }
                  </>
                ) : (
                  <>
                    <div className='messanger-sidebar'>
                      <div className='messanger-search-box'>
                        <div className='search-input-container'>
                          <span className='search-icon'><Icon icon="ic:round-search" width="24" height="24" /></span>
                          <input
                            type="text"
                            placeholder="Search....."
                            className='search-input'
                            onChange={handleSearchInputChange}
                            value={searchQuery}
                            onFocus={() => setInputFocused(true)}
                            onBlur={() => setInputFocused(false)}
                          />
                        </div>
                      </div>
                      <div className='messanger-users'>
                        <div className='messanger-users-details'>
                          {filteredClients.length === 0 ? (
                            <div>
                              <p style={{ fontSize: '15px', marginLeft: '0px', marginTop: '20px' }}>Match not found</p>
                            </div>
                          ) : (
                            filteredClients.map((client, index) => (
                              <div
                                className={`user-item ${selectedClient?.email === client.email ? 'selected' : ''}`}
                                key={index} onClick={() => handleMessageBox(client)}>
                                <div className='user-avatar'>
                                  <div className='user-avatar-circle'>
                                    {user.avatar || <Icon icon="lets-icons:user-fill" width="20" height="20" />}
                                  </div>
                                </div>
                                <div className='user-info'>
                                  <div className='user-name'>{client?.name}</div>
                                  {client?.unreadCount > 0 ? (
                                    <div className='user-subtitle'>{client?.unreadCount > 9 ? '9+' : client?.unreadCount}</div>
                                  ) : ''}

                                </div>
                                <div className='user-meta'>

                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='messanger-chat-board'>

                      {openMessage && selectedClient ? (
                        <div className='chat-container'>
                          <div className='chat-header'>
                            <div className='chat-user-info'>
                              <div className='user-avatar-circle'>
                                {selectedClient.name ? selectedClient.name.charAt(0).toUpperCase() : ""}
                              </div>
                              <div className='chat-user-details'>
                                <h3>{selectedClient && selectedClient.name}</h3>
                                <span className='user-status'>
                                  {isLeadOnline ? "online" : "offline"}
                                </span>
                              </div>
                              <div className='user-chat-clear-button' style={{ position: 'relative' }}>
                                <div
                                  className='chat-clear-button-icon'
                                  onClick={() => setShowClearDropdown((prev) => !prev)}
                                  style={{ cursor: 'pointer' }}>
                                  <Icon icon="qlementine-icons:menu-dots-16" width="24" height="24" color='#fff' />
                                </div>
                                {showClearDropdown && (
                                  <div className="clear-chat-dropdown" style={{
                                    position: 'absolute',
                                    top: '110%',
                                    right: 0,
                                    background: '#E76A34',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                    zIndex: 10,
                                    padding: '8px 0'
                                  }}>
                                    <div
                                      className="clear-chat-dropdown-item"
                                      style={{
                                        padding: '3px 10px',
                                        cursor: 'pointer',
                                        whiteSpace: 'nowrap',
                                        fontSize: "14px"
                                      }}
                                      onClick={() => {
                                        setShowClearDropdown(false);
                                      }}
                                    >
                                      Clear Chat
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="chat" ref={mainChatRef} id='element'>

                            {fetchedMessage.length > 0 ? (
                              fetchedMessage.map((msg, index) => {
                                const currentDate = new Date(msg.time);
                                const previousDate = index > 0 ? new Date(fetchedMessage[index - 1].time) : null;
                                const previousMsg = index > 0 ? fetchedMessage[index - 1] : null;
                                const showDate = index === 0 || !isSameDay(currentDate, previousDate);

                                let showAvatar = true;
                                if (previousMsg) {
                                  if (
                                    msg.from === previousMsg.from &&
                                    msg.to === previousMsg.to &&
                                    isSameDay(currentDate, new Date(previousMsg.time))
                                  ) {
                                    showAvatar = false;
                                  }
                                }

                                const firstUnreadIndex = fetchedMessage.findIndex(
                                  msg => msg.from === selectedClient.email && msg.read === false
                                );

                                // Determine whether to show "New Messages"
                                const showNewMessageDivider = index === firstUnreadIndex;

                                return (
                                  <React.Fragment key={index}>
                                    {showDate && <div className='show_date'><h4>{formatDate(currentDate)}</h4></div>}

                                    {showNewMessageDivider && (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          textAlign: "center",
                                          margin: "16px 0",
                                          color: "#e77949ff",
                                          fontWeight: "500",
                                        }}
                                      >
                                        <span
                                          style={{
                                            flex: 1,
                                            borderBottom: "0.5px solid #e77949ff",
                                            marginRight: "8px",
                                          }}
                                        />
                                        <span style={{ fontSize: "14px" }}>New Messages</span>
                                        <span
                                          style={{
                                            flex: 1,
                                            borderBottom: "0.5px solid #e77949ff",
                                            marginLeft: "8px",
                                          }}
                                        />
                                      </div>
                                    )}


                                    <div className='user-chat-history'>
                                      {msg.to === selectedClient.email ? (
                                        <>
                                          <div className="client_message-left">
                                            <div className="message-content">
                                              <div className='isecurion_wrap-data'>
                                                <p className='user-message'
                                                  dangerouslySetInnerHTML={{ __html: escapeHtml(msg.message).replace(/\n/g, '<br>') }} />
                                                <h6 className='message-date'>{formatTime(currentDate)}</h6>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="chat-avatar" style={{ visibility: showAvatar ? 'visible' : 'hidden' }}>
                                            {msg?.from?.charAt(0).toUpperCase() || "U"}
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="chat-avatar" style={{ visibility: showAvatar ? 'visible' : 'hidden' }}>
                                            {selectedClient?.name?.charAt(0).toUpperCase() || "U"}
                                          </div>

                                          <div className="isecurion_message_right">
                                            <div className="message-content">
                                              <div className='isecurion_wrap-data'>
                                                <p className='user-message'
                                                  dangerouslySetInnerHTML={{ __html: escapeHtml(msg.message).replace(/\n/g, '<br>') }} />
                                                <p className='message-date'>{formatTime(currentDate)}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </React.Fragment>
                                );
                              })
                            ) : (
                              <div className='empty_chat_message_client'>
                                <h1>Nothing's being discussed right now</h1>
                              </div>
                            )}

                            <div ref={messageRef} />
                          </div>

                          <div className='chat-input-container'>
                            <div className='chat-input-wrapper'>
                              <input
                                id='textarea'
                                type="text"
                                placeholder={selectedClient ? `Message ${selectedClient.name}` : 'Message ISECURION'}
                                value={message}
                                onChange={handleTextAreChange}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" && e.shiftKey) {
                                    e.preventDefault();
                                    insertNewLine(e);
                                  }
                                  else if (e.key === "Enter" && message.trim() !== "") {
                                    addMessage(e);
                                  }
                                }}
                                className='chat-input'
                              />

                              <button
                                className="message-send-icon"
                                onClick={addMessage}
                                disabled={hideSendButton}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  backgroundColor: "#E76A34",
                                  borderRadius: "50%",
                                  border: "none",
                                  cursor: hideSendButton ? "not-allowed" : "pointer",
                                  padding: 0,
                                  opacity: hideSendButton ? 0.5 : 1,
                                  filter: hideSendButton ? "grayscale(40%) brightness(0.8)" : "none",
                                }}
                                aria-label="Send message"
                                type="button"
                              >
                                <Icon icon="lsicon:send-filled" width="16" height="16" color="#fff" />
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className='no-chat-selected'>
                          <div className='no-chat-message'>
                            <img src={messageimage} />
                            <p>"Welcome! Connect and engage by diving into the conversation—<br />type your message below to get started."</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessengerComponent;

